import { useEffect } from 'react'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export default function useDocumentTitle(title) {
  useEffect(() => {
    if (title) {
      document.title = title
    }
  }, [title])
}
